module.exports = __webpack_public_path__ + "vue/img/icon-09.b4ae5561.png";